import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import HousingDetailItem2 from './HousingDetailItem2';
import Button from '../../../../components/common/Button';
import DetailButtonSection from '../../../../components/DetailButtonSection';
import {
  housingFundsDetailInputList4,
  housingFundsTypeOptions,
  ntsTypeOptions,
} from '../../../../common/data';
import DetailTitleSection from '../../../../components/DetailTitleSection';
import {
  getHousingFundsDataDetail4,
  resetDetailData,
  saveHousingFunds2,
  saveHousingFunds3,
} from '../housingFundsSlice';
import {
  formatDate,
  getAlertMessageFunction,
  getCurrentYear,
  getDeleteDialogConfig,
  handleNumberChange2,
  magamCertifyCheck,
} from '../../../../common/Util';
import SlideRightDialog from '../../../../components/common/SlideRightDialog';
import { isValidate04 } from '../util';
import { setIsDataModified } from '../../../common/commonSlice';

//주월세액
const Type4 = ({ onClose, isOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation('deductions/housingFunds');
  const { t: tCommon } = useTranslation('common');
  const inputList = housingFundsDetailInputList4(t);
  const codeLists = housingFundsTypeOptions(t);
  const ntsTypeList = ntsTypeOptions(tCommon);
  const { isMagam, isCertify } = useSelector(state => state.common);
  const { detailDataList, detailReload, workDay } = useSelector(state => state.housingFunds);
  const [dataList, setDataList] = useState([
    {
      htm001: '',
      htm004: '',
      htm005: '',
      htm011: '',
      htm012: '',
      htm016: '',
      htm017: '',
      htm018: '',
    },
  ]);

  useEffect(() => {
    if (isOpen) {
      dispatch(getHousingFundsDataDetail4({ hInType: '4' }));
    }

    return () => {
      dispatch(resetDetailData());
    };
  }, [dispatch, isOpen, detailReload]);

  useEffect(() => {
    if (detailDataList) {
      const formattedData = detailDataList.map(item => ({
        htmFlag: item.htmFlag,
        htmKFlag: item.htmKFlag,
        htmSeq: item.htmSeq,
        htmPDFFlag: item.htmPDFFlag || '',
        htmType: item.htmType || '',
        htm013: item.htm013, //근무기간 1
        htm014: item.htm014, //근무기간 2
        htm001: item.htm001, //월세액
        htm011: item.htm011, //임차기간
        htm012: item.htm012, //임차기간 2
        htm016: item.htm016, //임대인성명
        htm017: item.htm017, //임대인 주민(사업자)
        htm004: item.htm004, //주택유형
        htm005: item.htm005, //면적
        htm018: item.htm018, //임대차계약서주소지
      }));
      setDataList(formattedData);
    }
  }, [detailDataList]);

  const handleChange = (e, dataIndex) => {
    let { name, value } = e.target;

    if (name === 'htm005' || name === 'htm001') {
      value = handleNumberChange2(value);
    }
    console.log(name, value);
    console.log('dataIndex', dataIndex);
    dispatch(setIsDataModified(true));
    setDataList(prev => {
      const newData = [...prev];
      newData[dataIndex][name] = value;
      return newData;
    });
  };

  const handleAddButton = () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    setDataList(prev => {
      const newData = [...prev];
      newData.push({
        htmFlag: 'M',
        htmKFlag: '2',
        htmSeq: '',
        htm013: workDay == 'full' ? getCurrentYear() + '-01-01' : '', //근무기간 1
        htm014: workDay == 'full' ? getCurrentYear() + '-12-31' : '', //근무기간 2
        htm001: '', //월세액
        htm011: '', //임차기간
        htm012: '', //임차기간 2
        htm016: '', //임대인성명
        htm017: '', //임대인 주민(사업자)
        htm004: '', //주택유형
        htm005: '', //면적
        htm018: '', //임대차계약서주소지
      });
      return newData;
    });
  };

  const handleDeleteButton = dataIndex => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    let apiDelete = false;
    dataList[dataIndex].htmSeq != '' ? (apiDelete = true) : (apiDelete = false);

    if (apiDelete) {
      let formData = [
        {
          htmSeq: dataList[dataIndex].htmSeq,
        },
      ];

      const response = dispatch(
        getDeleteDialogConfig(tCommon, 'housingFunds3', { formData }),
      ).unwrap();

      return;
    }

    setDataList(prev => {
      const newData = [...prev];
      newData.splice(dataIndex, 1);
      return newData;
    });
  };
  const codeList = (key, pdfFlag) => {
    let list = [];
    if (key === 'htm004') {
      list = codeLists;
    } else if (key === 'htmKFlag') {
      if (pdfFlag) {
        list = ntsTypeList.filter(item => item.value !== '1');
      } else {
        list = ntsTypeList;
      }
    }
    return list.map((item, index) => {
      return (
        <option key={index} value={item.value}>
          {item.label}
        </option>
      );
    });
  };

  const handleSave = async () => {
    if (!magamCertifyCheck(isMagam, isCertify)) {
      return;
    }

    const alertMessage = getAlertMessageFunction();

    let formData = dataList.map(item => ({
      ...item,
      htm011: formatDate(item.htm011.replace(/-/g, '')),
      htm012: formatDate(item.htm012.replace(/-/g, '')),
      htm013: formatDate(item.htm013.replace(/-/g, '')),
      htm014: formatDate(item.htm014.replace(/-/g, '')),
    }));

    if (!isValidate04(dataList, t)) {
      return;
    }

    try {
      const response = await dispatch(saveHousingFunds3({ formData: [...formData] })).unwrap();
      if (response.resultCode === 'OK') {
        alertMessage('저장하였습니다');
        onClose();
      } else {
        alertMessage('월세액 저장에 실패하였습니다.', 'error');
      }
    } catch (error) {
      console.log(error);
      alertMessage('월세액 저장에 실패하였습니다.', 'error');
    }
  };

  return (
    <SlideRightDialog onClose={onClose} isOpen={isOpen}>
      <div className="displayFlexColumn" style={{ gap: '24px' }}>
        <DetailTitleSection title={`${t('detail.title4')}`} />

        {dataList?.map((data, dataIndex) => {
          let disabled = data.htmType == '1' && data.htmPDFFlag == '2' && data.htmKFlag == '1';
          return (
            <HousingDetailItem2
              key={dataIndex}
              {...{
                inputList,
                dataList,
                data,
                handleChange,
                handleAddButton,
                handleDeleteButton,
                dataIndex,
                codeList,
                title: `${t('detail.title4')}`,
                disabled,
              }}
            />
          );
        })}
        <Button
          value={t('detail.addButton2')}
          style={{ width: '100%' }}
          addButton
          color="sub"
          onClick={handleAddButton}
        />
        {/* 취소,저장버튼 */}
        <DetailButtonSection onSave={handleSave} onClose={onClose} />
      </div>
    </SlideRightDialog>
  );
};

export default Type4;
